module.exports = __webpack_public_path__ + "img/商标异议_11.92740f0b.jpg";